import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/api';

const POSITIONINGS_TAG = 'Positionings';

export const positioningsApi = createApi({
  reducerPath: 'positioningsApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/projects/',
  }),
  tagTypes: [POSITIONINGS_TAG],
  endpoints: builder => ({
    // Fetch Positionings by Competitors IDs
    fetchCompetitorPositionings: builder.query({
      query: ({ projectId, productId, competitorIds = [] }) => ({
        url: `${projectId}/products/${productId}/positionings/?competitor=${competitorIds.join(',')}`,
      }),
      providesTags: [POSITIONINGS_TAG],
    }),

    // Create a new Positioning
    createPositioning: builder.mutation({
      query: ({ projectId, productId, competitorId, rating, attribute, name }) => ({
        url: `${projectId}/products/${productId}/positionings/`,
        method: 'POST',
        data: { rating, attribute, name, competitor: competitorId },
      }),
      invalidatesTags: [POSITIONINGS_TAG],
    }),

    // Update a Positioning
    updatePositioning: builder.mutation({
      query: ({ projectId, productId, positioningId, rating }) => ({
        url: `${projectId}/products/${productId}/positionings/${positioningId}/`,
        method: 'PATCH',
        data: { rating },
      }),
      invalidatesTags: [POSITIONINGS_TAG],
    }),
  }),
});

export const {
  useFetchCompetitorPositioningsQuery,
  useCreatePositioningMutation,
  useUpdatePositioningMutation,
} = positioningsApi;
